import React from "react";
import SuperAdminHeader from "../../components/superAdminCompoents/SuperAdminHeader";
import AdminTittle from "../../components/adminComponents/AdminTittle";
import AdminSideBar from "../../components/adminComponents/AdminSideBar";
const SuperAdminSubCompanyPage = () => {
  return (
    <>
      {/* <SuperAdminHeader />
            <AdminSideBar /> */}
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <AdminTittle title="Subscription" />
          </div>
        </div>
      </div>
    </>
  );
};
export default SuperAdminSubCompanyPage;
